import React, { useState, useEffect } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import truck from "../../assets/bgtruck.svg";
import logo from "../../assets/Logo.svg";
import fb from "../../assets/fb.svg";
import twitter from "../../assets/twitter.svg";
import linkedin from "../../assets/linkedin.svg";
import Footer from "./Footer";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

export default function App() {
  const [openIndex, setOpenIndex] = useState(0); // first open
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // ✅ Fetch FAQs
  const getAllFaq = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
         `${BASE_URL}/static/faq/All`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("getAllFaq API response:", response.data);
      setFaqs(response.data?.data || []);
    } catch (error) {
      console.error(
        "API Error (getAllFaq):",
        error.response?.data || error.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllFaq();
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      {/* Background Section (Navbar + Content) */}
      <div
        className="relative flex flex-col bg-cover bg-center bg-fixed text-white"
        style={{ backgroundImage: `url(${truck})` }}
      >
        {/* Global dark overlay to make text pop */}
        <div className="absolute inset-0 bg-black/80 z-0"></div>

        {/* Content wrapper */}
        <div className="relative z-10 flex flex-col flex-grow">
          {/* Top Navbar */}
          <div className="w-full flex flex-col sm:flex-row justify-between items-center px-4 sm:px-12 py-8">
            {/* Social Icons */}
            <div className="flex gap-5 text-white text-lg sm:text-xl mb-4 sm:mb-0">
              <img src={twitter} alt="Twitter" className="cursor-pointer w-6 h-6 hover:scale-110 transition-transform opacity-80 hover:opacity-100" />
              <img src={fb} alt="Facebook" className="cursor-pointer w-6 h-6 hover:scale-110 transition-transform opacity-80 hover:opacity-100" />
              <img src={linkedin} alt="LinkedIn" className="cursor-pointer w-6 h-6 hover:scale-110 transition-transform opacity-80 hover:opacity-100" />
            </div>

            {/* Logo */}
            <Link to="/" className="text-white font-bold text-xl sm:text-2xl tracking-wider">
              <img src={logo} alt="Logo" className="w-[180px] sm:w-[220px] h-auto mx-auto drop-shadow-lg" />
            </Link>

            {/* Buttons */}
            <div className="flex gap-4 mt-4 sm:mt-0">
              <button
                onClick={() => navigate("/login")}
                className="bg-purple-600 hover:bg-purple-700 text-white px-6 sm:px-10 py-3 rounded-full font-bold transition-all shadow-lg hover:shadow-purple-500/30"
              >
                Log In
              </button>
              <button
                onClick={() => navigate("/signup")}
                className="bg-white/10 hover:bg-white/20 border border-white/20 backdrop-blur-md text-white px-6 sm:px-10 py-3 rounded-full font-bold transition-all"
              >
                Sign Up
              </button>
            </div>
          </div>

          {/* Main Content Area */}
          <div className="flex-grow flex flex-col items-center px-4 sm:px-8 py-12 sm:py-24">
            <div className="max-w-4xl w-full">
              <h1 className="text-[42px] sm:text-[72px] font-inter font-extrabold text-center mb-6 drop-shadow-2xl">
                FAQs
              </h1>
              <p className="text-gray-300 text-center text-lg sm:text-2xl mb-16 max-w-3xl mx-auto leading-relaxed">
                Smart Dispatch Software and Driver App built for fast-growing logistics companies.
              </p>

              {/* FAQ Accordion Section */}
              <div className="space-y-4 mb-20">
                {loading ? (
                  <div className="flex justify-center py-20">
                    <div className="w-12 h-12 border-4 border-purple-500 border-t-transparent rounded-full animate-spin"></div>
                  </div>
                ) : faqs.length > 0 ? (
                  faqs.map((item, index) => (
                    <div
                      key={item._id || index}
                      className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl overflow-hidden transition-all duration-300 hover:bg-white/10"
                    >
                      <button
                        onClick={() => setOpenIndex(openIndex === index ? null : index)}
                        className="w-full flex justify-between items-center px-6 sm:px-8 py-5 text-left font-bold text-white focus:outline-none"
                      >
                        <span className="text-[17px] sm:text-[20px]">{item.question}</span>
                        {openIndex === index ? (
                          <FaChevronUp className="text-purple-500 text-xl flex-shrink-0" />
                        ) : (
                          <FaChevronDown className="text-gray-400 text-xl flex-shrink-0" />
                        )}
                      </button>
                      {openIndex === index && (
                        <div className="px-6 sm:px-8 py-6 text-[16px] sm:text-[18px] text-gray-300 border-t border-white/10 leading-relaxed bg-white/5">
                          {item.answer}
                        </div>
                      )}
                    </div>
                  ))
                ) : (
                  <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-12 text-center">
                    <p className="text-gray-400 text-xl font-medium">No FAQs found at the moment.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
